import journeyFolder from "assets/images/journeyFolder.svg"
import journeyFolderCompleted from "assets/images/journeyFolderCompleted.svg"
import { modifiers } from "ui-tools"
import s from "./JourneyFolderIcon.module.scss"

export const JourneyFolderIcon = ({
  isCompleted,
}: {
  isCompleted: boolean
}) => (
  <div className={modifiers(s, "journeyFolderIcon", { isCompleted })}>
    <img src={isCompleted ? journeyFolderCompleted : journeyFolder} alt="" />
  </div>
)
